import React from "react";
import styles from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";
import SingleCard from "./SingleCard";

const FeaturesAndBenefits = ({ data }) => {
  const features = data?.fnb_cards;
  return (
    <section className={styles.section}>
      <div className={"container"}>
        {/* Title Section */}
        <div className={styles.titleSection}>
          <div className={styles.title}>
            <PrismicRichText field={data?.fnb_title} />
          </div>
          <div className={styles.description}>
            <PrismicRichText field={data?.fnb_description} />
          </div>
        </div>

        {/* Features Grid */}
        <div className={styles.featuresGrid}>
          {features.map((feature, index) => (
            <SingleCard key={index} item={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesAndBenefits;
